/**@author Hieu Manh */
import React, { useMemo } from "react";
import { RegisterOptions, useController } from "react-hook-form";
import { StyleProp, StyleSheet, TextStyle } from "react-native";
import { HelperText, useTheme } from "react-native-paper";
import { Block } from "../../blocks/block";
import { DatePickerInput } from "react-native-paper-dates";
import { useTranslation } from "react-i18next";
import moment from "moment";

interface InputSelectPickerProps {
  control: any;
  name: string;
  inputProps?: object;
  style?: StyleProp<TextStyle>;
  label: string;
  rules?: Omit<RegisterOptions, "valueAsNumber" | "valueAsDate" | "setValueAs">;
  value?: string;
  onChangeDate?: (value?: string) => void;
}

export const InputSelectPicker = (props: InputSelectPickerProps) => {
  const { control, name, style = {}, inputProps, label, rules, value, onChangeDate = () => {} } = props;
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: "",
  });
  const { colors } = useTheme();
  const { i18n } = useTranslation();

  const styles = useMemo(
    () =>
      StyleSheet.create({
        inputStyle: {
          flex: 1,
          color: colors.accent,
          backgroundColor: colors.backgroundForm,
          fontWeight: "700",
          textShadowColor: "black",
        },
      }),
    [colors],
  );

  const [selectDate, setSelectDate] = React.useState<string | undefined>(value);

  const handleChange = () => (_date?: Date) => {
    let dateNew = moment(moment.now()).format("DD/MM/YYYY");
    if (_date) dateNew = moment(_date).format("DD/MM/YYYY");
    setSelectDate(dateNew);
    field.onChange(dateNew);
    onChangeDate(dateNew);
  };

  return (
    <>
      <Block row w={"100%"}>
        <DatePickerInput
          activeOutlineColor={colors.accent}
          activeUnderlineColor={colors.accent}
          onPressIn={() => {}}
          onPressOut={() => {}}
          mode={"flat"}
          locale={i18n.language}
          label={label}
          value={moment(selectDate, "DD/MM/YYYY").toDate()}
          onChange={handleChange()}
          outlineColor={"transparent"}
          inputMode="start"
          theme={{
            colors: {
              primary: colors.accent,
              text: colors.accent,
              error: colors.error,
            },
          }}
          {...inputProps}
          style={[styles.inputStyle, style]}
          error={invalid}
          withDateFormatInLabel={false}
        />
      </Block>
      {invalid && error?.message && (
        <HelperText type="error" visible={invalid}>
          {error?.message}
        </HelperText>
      )}
    </>
  );
};
